// Copyright (c) 2016 Deere & Company

import {combineReducers} from 'redux';
import {getCombinedReducers as getAllPartsCombinedReducers} from './all-parts-requests/reducers';
import {getCombinedReducers as getOpenPartsCombinedReducers} from './open-parts-requests/reducers';
import {getCombinedReducers as getRequestDetailsCombinedReducers} from './request-details/reducers';
import {getCombinedReducers as getSearchCombinedReducers} from './search/reducers';

export const getCombinedReducers = () => combineReducers({
    allPartReturns: getAllPartsCombinedReducers(),
    openPartReturns: getOpenPartsCombinedReducers(),
    requestDetails: getRequestDetailsCombinedReducers(),
    search: getSearchCombinedReducers()
});



// WEBPACK FOOTER //
// ./src/part-requests/part-requests-reducers.js